import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {AccountsAlerts} from "../../services/accounts-alerts.service";
import {$accountFactory} from "../../$account.factory";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ShipperAccountBranchesCtrl implements IController {

  account: AccountModel;
  branchIds: string[];

  private accountRef: any;
  private loading: boolean;
  private noBranches: any;
  private canUpdate: any;

  constructor(private accountsAlerts: AccountsAlerts, private IAMPermissions, private $log,
              private $account: $accountFactory,
              private branchesDialogService: BranchesDialogService, private confirmDialogService: ConfirmDialogService) {
  }

  $onInit() {
    this.loading = false;
    this.noBranches = [null];
    this.canUpdate = this.IAMPermissions.hasPermission('accounts.demand.update');

    this.accountRef = this.$account(this.account.id);
    this.branchIds = this.account.branchIds;
    if (!this.branchIds || !this.branchIds.length) {
      this.branchIds = [null];
    }
  }

  onAddBranches(event) {
    this.branchesDialogService.branchesSelect(event, this.branchIds)
      .then((branchIds) => {
        const accountCopy = angular.copy(this.account);

        if (!accountCopy.branchIds) {
          accountCopy.branchIds = [];
        }

        accountCopy.branchIds = accountCopy.branchIds.concat(branchIds);

        this.loading = true;
        return this.accountRef.$update(accountCopy);
      })
      .then((updatedAccount) => {
        this.branchIds = updatedAccount.branchIds;
        this.accountsAlerts.demandAddToBranchSuccess();
      })
      .catch((error) => {
        if (error) {
          this.accountsAlerts.demandAddToBranchError();
          this.$log.error('Failed to add branch to account @shipperAccountBranches@onAddBranch', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onRemoveBranch(branchToRemove, event) {
    this.confirmDialogService.confirm('Remove Branch', 'Are you sure you want to remove this branch?', event)
      .then(() => {
        const accountCopy = angular.copy(this.account);
        accountCopy.branchIds = _.without(this.account.branchIds, branchToRemove.id);
        return this.accountRef.$update(accountCopy);
      })
      .then((updatedAccount) => {
        if (!updatedAccount.branchIds.length) {
          updatedAccount.branchIds = [null];
        }
        this.branchIds = updatedAccount.branchIds;
        this.accountsAlerts.demandRemoveFromBranchSuccess(updatedAccount);
      })
      .catch((error) => {
        if (error) {
          this.accountsAlerts.demandRemoveFromBranchError();
          this.$log.error('Failed to remove branch from account @shipperAccountBranches@onRemoveBranch', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      });
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountBranches', {
    bindings: {
      account: '<'
    },
    template: require('./shipper-account-branches.html').default,
    controller: ShipperAccountBranchesCtrl
  });
